import { get } from 'lodash'
import { errorConstants } from '../../constants/errorConstants'
import { apiErrorMessages } from './apiErrorMessages.js'

export function getErrorMessage(err) {
  if (!err?.status) {
    return apiErrorMessages.GENERAL.somethingWentWrong
  }

  const errorText =
    err.body || JSON.parse(err.response?.text || '{}') || err.response || err

  // Try to match a named API error
  if (errorText?.name) {
    const errorName = errorText.name
    const isErrorDetailsExist =
      errorText?.details && errorText?.details.length > 0
    let errorMsg = '',
      fieldBasedError = []
    if (isErrorDetailsExist && errorText?.details.length > 0) {
      errorMsg = apiErrorMessages.VALIDATE_FORM_GENERIC_MESSAGE
      // eslint-disable-next-line no-unused-expressions
      errorText?.details.forEach((element) => {
        if (element?.field) {
          const field = element.field.replace(/\//g, '') || ''
          const fieldError = {
            field,
            msg: apiErrorMessages[element?.issue][field],
          }
          // push only if field not already in fieldBasedError
          const exists = fieldBasedError.some(
            (errorField) => errorField.field === field,
          )
          if (!exists) {
            fieldBasedError.push(fieldError)
          }
        } else {
          errorMsg = apiErrorMessages[element?.issue]
        }
      })
    } else {
      errorMsg = apiErrorMessages[errorName]
    }

    errorMsg =
      errorMsg ||
      errorConstants[err.status]?.message ||
      apiErrorMessages.GENERAL.somethingWentWrong

    return { msg: errorMsg, fieldBasedError }
  }

  // Handle client-side error with specific message
  if (get(errorText, 'clientError')) {
    return get(errorText, 'errorMessage', '')
  }

  return apiErrorMessages.GENERAL.somethingWentWrong
}

export function constructErrorMessage(err) {
  const status = get(err, 'status')

  if (!status) {
    return {
      msg: apiErrorMessages.GENERAL.sessionExpired,
      status: 'error',
    }
  }

  if (status === 401) {
    return {
      msg:
        errorConstants[status]?.message ||
        apiErrorMessages.GENERAL.unauthorized,
      status: 'error',
    }
  }

  return {
    ...getErrorMessage(err),
    status: 'error',
  }
}

export default {
  constructErrorMessage,
}
